import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { format, isWithinInterval} from "date-fns";
import ptBR from "date-fns/esm/locale/pt-BR/";
import {
  MdArrowDropUp,
  MdArrowDropDown,
  MdOutlineFileDownload,
} from "react-icons/md";

import Accessibility from "../../../components/UI/Accessibility";
import ContentBox from "../../../components/UI/ContentBox";
import Footer from "../../../components/UI/Footer";
import Menu from "../../../components/UI/Menu";
import {
  Container,
  Item,
  ItemContent,
  Text,
  Button,
  Link,
} from "./styles";
import Banner from "../../../components/UI/Banner";

import useApi from "../../../hooks/useApi";
import { useAuth } from "../../../hooks/useAuth";

import ReadMoreButton from "../../../components/UI/ReadMoreButton";
import FullScreenLoading from "../../../components/UI/FullScreenLoading";
import { images } from "../../../constants";

const ListForms = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const { user } = useAuth();

  const [sp, setSP] = useState({});

  const [context, setContext] = useState([]);

  const [forms, setForms] = useState([]);

  const [open, setOpen] = useState("");

  const [loadForms, loadFormsInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/contextEvaluation/activities",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("loadForms",response);
        setForms(response.data);
      }
    },
  });

  const [loadContext, loadContextInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/contextEvaluation",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        if(response.data.length>0){
          setContext(response.data[0]);
        }
      }
    },
  });
  
  useEffect(() => {
    if(id){
      loadContext({
        params: {
          id,
        },
      });

      loadForms({
        params: {
          idContent: id,
        },
      });
    }
    if(user){
      setSP(user.profiles[0].specialPermissions.find((sp)=>{return sp.area==="forms"}).accessRights.find((category)=>{return category.idcategory==="41a9f494-0378-4272-b7d7-320e2a61f699"}));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("sp",sp);
    // eslint-disable-next-line
  }, [sp]);

  useEffect(() => {
    console.log("context",context);
    // eslint-disable-next-line
  }, [context]);

  return (
    <Container>
      {(
        loadFormsInfo.loading ||
        loadContextInfo.loading
      ) && <FullScreenLoading />}
      <Menu />
      <Banner icon={images.iconForms}>Avaliação de Contexto</Banner>
      <ContentBox>

        {forms.map((form)=><Item key={form.idContentActivity} visible={open===form.idContentActivity||open===""} onClick={()=>{setOpen(open===""?form.idContentActivity:"")}}>
          {form.title}{open===form.idContentActivity?<MdArrowDropUp size={30}/>:<MdArrowDropDown size={30}/>}
        </Item>)}
        {forms.filter((form)=>{return form.idContentActivity===open}).map((form)=><>
          {
            form.forms.map((formActivity)=><ItemContent key={formActivity.idform}>
              <Text>
                <div>Dimensão Pedagógica: <b>{formActivity.title}</b></div>
                {/* <div>{formActivity.description}</div> */}
                <div>Disponível no período de: 
                  {format(new Date(formActivity.publishBegin), " dd/MM/yyyy ", {locale: ptBR,})}
                  a
                  {format(new Date(formActivity.publishEnd), " dd/MM/yyyy", {locale: ptBR,})}
                </div>
                {form.documents.length>0 && <div>
                  Documentos:<br/>
                  {form.documents.map((document)=>
                    <Link href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/contextEvaluation/activities/${document.url}`} target="_blank">
                      {`${document.originalName}`} <MdOutlineFileDownload />
                    </Link>
                  )}
                </div>}
              </Text>
              <Button>
                {sp.can_answer && 
                (isWithinInterval(new Date(), {start:new Date(formActivity.publishBegin),end:new Date(formActivity.publishEnd)})||
                user.profiles[0]?.idProfile==="b56d58fe-2377-4428-854d-5f20670fb166") && <ReadMoreButton
                  text="Acessar Formulário"
                  onClick={()=>{navigate(`/formularios/listarrespostas/${formActivity.idform}`)}}
                />}
              </Button>
            </ItemContent>)
          }
        </>)}

        <ReadMoreButton text={"Voltar"} onClick={()=>{
                    navigate(`/avaliacaocontexto`)
                  }}/>
    
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ListForms;
